import { Account, AccountType } from '@mews-commander/data-access';
import { DateService, Date, WallClockDateService } from '@mews/framework';
import { Icon } from '@optimus-web/core';
import { IconName } from '@optimus-web/icons';

interface BirthDayIconProps {
    account: Account;
    reportFilterDate: Date;
}

export const BirthDayIcon: React.FC<BirthDayIconProps> = ({ account, reportFilterDate }) => {
    if (account.data.discriminator !== AccountType.Customer || !account.data.value.birthDate) {
        return null;
    }

    const birthDateDate = WallClockDateService.toTimezonedDate(
        WallClockDateService.parse(account.data.value.birthDate),
        reportFilterDate.timezone
    );
    const hasBirthday =
        DateService.getMonth(reportFilterDate) === DateService.getMonth(birthDateDate) &&
        DateService.getDate(reportFilterDate) === DateService.getDate(birthDateDate);

    return hasBirthday ? <Icon value={IconName.Birthday} size="small" /> : null;
};
